/**
 * トグルボタン
 */
export default class ToggleButton extends HTMLElement {
  constructor() {
    super();

    const buttonList = this.querySelectorAll('button');
    buttonList.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttonList.forEach((button) => {
          button.setAttribute('aria-checked', 'false');
        });
        buttonList[index].setAttribute('aria-checked', 'true');
        if (this.dataset.target === 'accepts_marketing') {
          this.updateMarketing(buttonList[index]);
        }
      });
    });
  }
  updateMarketing(button) {
    const form = document.querySelector('#cf-edit-profile-form');
    const input = form.querySelector('input[name="acceptsMarketing"]');
    const checked = button.dataset.acceptsMarketing === 'true' ? true : false;
    if (checked) {
      input.setAttribute('checked', checked);
    } else {
      input.removeAttribute('checked');
    }

    this.closest('.unico-mypage-block').querySelector(
      '.unico-mypage-toggle-value',
    ).innerHTML = `${
      Shopify.locale == 'ja' ? '現在の設定 :' : 'Accepts Marketing :'
    } ${button.textContent}`;
    form.querySelector('button').click(true);
  }
}
